// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// React Router

// MainStore
import { MainStore } from '../stores/MainStore';

// Managers
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

// Components
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

interface State {
  cards: any;
  files: any;
  filesDroguerie: any;
  image: any;
  droguerieImage: any;
  droguerieImages: any;
}

interface Props {
  navigation: any;
}

/**
 * @description Home View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Home extends React.Component<Props, State> {

  /**
   * Creates an instance of Home.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
    this.state = {
      cards: [],
      droguerieImage: "",
      droguerieImages: [],
      files: "",
      filesDroguerie: "",
      image: ""
    };
  }

  async componentWillMount() {
      await NetworkManager.request(`home`, MethodRequest_e.GET).then((image: any) => {
        this.setState({
          image: image
        });
      });
  }

  componentDidMount() {
    document.title = "SO Tramelan | Accueil";
  }

  baseName(str: any) {
   let base = new String(str).substring(Number(str.lastIndexOf('/')) + 1);
    if(base.lastIndexOf(".") != -1) {
      base = base.substring(0, base.lastIndexOf("."));
    }
    return base;
}

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
        MainStore.showOverlay(`Modification de l'image en cours...`);

        try {
          await NetworkManager.request(
            `home`, MethodRequest_e.POST, {
              image: this.state.image
            }).then((response) => {
              MainStore.showNotification(response.text);
            });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
    };
  }

  handleMainImageChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        files: file,
        image: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  handleDroguerieImageChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        droguerieImage: reader.result,
        filesDroguerie: file
      });
    };

    reader.readAsDataURL(file);
  }

  /**
   * @description Render the HomeView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    return (
      <div>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={12}>
            <Typography variant="headline" gutterBottom={true}>Accueil</Typography>
          </Grid>
          <Grid item={true} xs={12} md={4} className="form-field">
            <Typography variant="body2">Image principale</Typography>
            <input
              accept="image/*"
              id="raised-button-file"
              type="file"
              onChange={this.handleMainImageChange}
              hidden={true}
            />
            <img src={this.state.image} />
            <br/>

            <label htmlFor="raised-button-file">
              <Button color="primary" size="small" variant="contained" component="span">Sélectionner image</Button>
            </label>
            <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>Modifier</Button>
          </Grid>
          </Grid>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Home.tsx